import { render, staticRenderFns } from "./Index3.vue?vue&type=template&id=72809c92&scoped=true&"
import script from "./Index3.vue?vue&type=script&lang=js&"
export * from "./Index3.vue?vue&type=script&lang=js&"
import style0 from "./Index3.vue?vue&type=style&index=0&id=72809c92&prod&lang=scss&"
import style1 from "./Index3.vue?vue&type=style&index=1&id=72809c92&prod&lang=scss&scoped=true&"
import style2 from "./Index3.vue?vue&type=style&index=2&id=72809c92&prod&lang=scss&"
import style3 from "./Index3.vue?vue&type=style&index=3&id=72809c92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72809c92",
  null
  
)

export default component.exports